import React, { useState, useEffect } from 'react';
import '../../styles/Website/Markets.css';

function Markets() {
  const [marketData, setMarketData] = useState([
    { 
      icon: '💱', 
      name: 'EUR/USD', 
      price: 1.0875,
      change: 0.23,
      trend: 'up',
      category: 'Forex CFDs',
      basePrice: 1.0875
    },
    { 
      icon: '🛢️', 
      name: 'Crude Oil', 
      price: 78.45,
      change: -0.15,
      trend: 'down',
      category: 'Commodities CFDs',
      basePrice: 78.45
    },
    { 
      icon: '📈', 
      name: 'AAPL', 
      price: 182.34,
      change: 1.45,
      trend: 'up',
      category: 'Stocks CFDs',
      basePrice: 182.34
    },
    { 
      icon: '📊', 
      name: 'S&P 500', 
      price: 4567.89,
      change: 0.67,
      trend: 'up',
      category: 'Index CFDs',
      basePrice: 4567.89
    },
    { 
      icon: '📜', 
      name: 'US 10Y Bond', 
      price: 4.234,
      change: -0.05,
      trend: 'down',
      category: 'Bond CFDs',
      basePrice: 4.234
    },
    { 
      icon: '₿', 
      name: 'BTC/USD', 
      price: 43256,
      change: 2.34,
      trend: 'up',
      category: 'Cryptocurrency CFD',
      basePrice: 43256
    },
    { 
      icon: '📉', 
      name: 'Gold Futures', 
      price: 2045.30,
      change: 0.89,
      trend: 'up',
      category: 'Futures CFD',
      basePrice: 2045.30
    }
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      setMarketData(prevData => 
        prevData.map(market => {
          // Simulate realistic price movement
          const volatility = market.name.includes('BTC') ? 0.005 : 
                            market.name.includes('Oil') ? 0.003 :
                            market.name.includes('EUR') ? 0.0008 : 0.002;
          
          const randomChange = (Math.random() - 0.5) * 2 * volatility;
          const newPrice = market.price * (1 + randomChange);
          
          // Calculate change from base price
          const changePercent = ((newPrice - market.basePrice) / market.basePrice) * 100;
          const trend = randomChange > 0 ? 'up' : 'down';
          
          return {
            ...market,
            price: newPrice,
            change: changePercent,
            trend
          };
        })
      );
    }, 1500); // Update every 1.5 seconds

    return () => clearInterval(interval);
  }, []);

  const formatPrice = (market) => {
    if (market.name.includes('Bond')) {
      return `${market.price.toFixed(3)}%`;
    } else if (market.name.includes('EUR') || market.name.includes('Gold')) {
      return market.price.toFixed(4);
    } else if (market.name.includes('BTC')) {
      return market.price.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return market.price.toFixed(2);
    }
  };

  const marketCategories = [
    { name: 'Forex CFDs', count: '61 products' },
    { name: 'Commodities CFDs', count: '24 products' },
    { name: 'Stocks CFDs', count: '+2100 products' },
    { name: 'Index CFDs', count: '25 products' },
    { name: 'Bond CFDs', count: '9 products' },
    { name: 'Cryptocurrency CFD', count: '21 products' },
    { name: 'Futures CFD', count: '4 products' }
  ];

  return (
    <section className="markets" id="markets">
      <div className="container-wide">
        <div className="markets-grid">
          <div className="markets-visual">
            <div className="laptop-mockup">
              <div className="laptop-screen">
                <div className="trading-platform">
                  <div className="live-prices-header">
                    <h3>Live Market Prices</h3>
                    <span className="live-indicator">🔴 LIVE</span>
                  </div>
                  <div className="live-prices-list">
                    {marketData.map((market, index) => (
                      <div className={`price-row ${market.trend}`} key={index}>
                        <div className="price-left">
                          <span className="market-icon">{market.icon}</span>
                          <span className="market-symbol">{market.name}</span>
                        </div>
                        <div className="price-right">
                          <span className="market-price">
                            {formatPrice(market)}
                          </span>
                          <span className={`market-change ${market.trend}`}>
                            {market.change >= 0 ? '+' : ''}{market.change.toFixed(2)}%
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="markets-content">
            <h2 className="section-title-large" style={{color: 'white'}}>Global Markets at Your Fingertips</h2>
            
            <div className="markets-list">
              {marketCategories.map((market, index) => (
                <div className="market-item" key={index}>
                  <div className="market-info">
                    <span className="check-icon-market">✓</span>
                    <span className="market-name">{market.name}</span>
                  </div>
                  <span className="market-count">{market.count}</span>
                </div>
              ))}
            </div>

            <button className="btn-cta-secondary">Range of Markets</button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Markets;